import React from "react";
import Typography from "@material-ui/core/Typography";
const StockManagement = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Stock Management
      </Typography>
      <Typography paragraph variant="h5">
        Organize all the stock received and issued
      </Typography>
      <Typography paragraph variant="body1">
        Stock Management is one of the features under the Inventory module to
        perform inventory transactions particularly to handle goods movements
        under each warehouse or outlet. It contains any information regarding
        the goods issued & goods received, stock counting, stock availability,
        stock reservation, stock transfer, and process order.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Stock Management
        feature list. The Stock Management is divided into 2 location types:
        Warehouse and Outlet. All the Stock Management features are displayed
        like a table that contains download functions, sort, filter, and global
        search on the header area, and contains data navigation and refresh
        function on the footer area. Below is the tab structure representing all
        features under Stock Management:
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Warehouse Stock Management</b>
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            <b>Warehouse Info</b> : This tab is to display the Warehouse data.
          </li>
          <li>
            <b>Goods Received</b> : This tab is to display & manage any Goods
            Received related to the Warehouse. There are 5 sub-menus under this
            tab with below detail:
            <ul>
              <li>
                <b>Purchase Order</b> : This tab is to display & manage any
                Goods Received from Purchase Order related to the Warehouse.
              </li>
              <li>
                <b>Items Transfer</b> : This tab is to display & manage any
                Goods Received from Items Transfer related to the Warehouse.
              </li>
              <li>
                <b>Sales Journey</b> : This tab is to display & manage any Goods
                Received from Sales Journey related to the Warehouse.
              </li>
              <li>
                <b>Sales Return</b> : This tab is to display & manage any Goods
                Received from Sales Return related to the Warehouse.
              </li>
              <li>
                <b>GR History</b> : This tab is to display any Goods Received
                History related to the Warehouse.
              </li>
            </ul>
          </li>
          <li>
            <b>Goods Issued</b> : This tab is to display & manage any Goods
            Issued related to the Warehouse.
          </li>
          <li>
            <b>Process Order</b> : This tab is to display & manage any Process
            Order related to the Warehouse. There are 3 sub-menus under this tab
            with below detail:
            <ul>
              <li>
                <b>Sales Order</b> : This tab is to display & manage any Sales
                Order which ready to be processed related to the Warehouse. Any
                items that have been processed will exist in Items Reservation.
              </li>
              <li>
                <b>Items Request</b> : This tab is to display & manage any Items
                Request which ready to be processed related to the Warehouse.
                Any items that have been processed will exist in Items
                Reservation.
              </li>
              <li>
                <b>Items Reservation</b> : This tab is to display & manage any
                Items Reservation related to the Warehouse.
              </li>
            </ul>
          </li>
          <li>
            <b>Purchase Request</b> : This tab is to display & manage any
            Purchase Request related to the Warehouse.
          </li>
          <li>
            <b>Manage Stock</b> : This tab is to display & manage any Stock
            Management related to the Warehouse Stock. There are 6 sub-menus
            under this tab with below detail:
            <ul>
              <li>
                <b>Items Transfer</b> : This tab is to display & manage any
                Items Transfer related to the Warehouse Stock.
              </li>
              <li>
                <b>Unit Conversion</b> : This tab is to display & manage any
                Unit Conversion related to the Warehouse Stock.
              </li>
              <li>
                <b>Stock Opname</b> : This tab is to display & manage any Stock
                Opname related to the Warehouse Stock.
              </li>
              <li>
                <b>Safe Stock</b> : This tab is to display & manage any Safe
                Stock related to the Warehouse Stock.
              </li>
              <li>
                <b>Stock Movement</b> : This tab is to display any Stock
                Movement related to the Warehouse Stock.
              </li>
              <li>
                <b>Stock List</b> : This tab is to display any Stock List
                related to the Warehouse Stock.
              </li>
            </ul>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Outlet Stock Management</b>
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            <b>Outlet Info</b> : This tab is to display the Outlet data.
          </li>
          <li>
            <b>Goods Received</b> : This tab is to display & manage any Goods
            Received related to the Outlet.
          </li>
          <li>
            <b>Point Of Sales</b> : This tab is to display & manage any Point Of
            Sales related to the Outlet. There are 2 sub-menus under this tab
            with below detail:
            <ul>
              <li>
                <b>Items Reservation</b> : This tab is to display & manage any
                Items Reservation related to the Outlet Point Of Sales.
              </li>
              <li>
                <b>Goods Issued</b> : This tab is to display & manage any Goods
                Issued related to the Outlet Point Of Sales.
              </li>
            </ul>
          </li>
          <li>
            <b>Manage Stock</b> : This tab is to display & manage any Stock
            Management related to the Outlet Stock. There are 6 sub-menus under
            this tab with below detail:
            <ul>
              <li>
                <b>Items Request</b> : This tab is to display & manage any Items
                Request related to the Outlet Stock.
              </li>
              <li>
                <b>Items Transfer</b> : This tab is to display & manage any
                Items Transfer related to the Outlet Stock.
              </li>
              <li>
                <b>Stock Opname</b> : This tab is to display & manage any Stock
                Opname related to the Outlet Stock.
              </li>
              <li>
                <b>Safe Stock</b> : This tab is to display & manage any Safe
                Stock related to the Outlet Stock.
              </li>
              <li>
                <b>Stock Movement</b> : This tab is to display any Stock
                Movement related to the Outlet Stock.
              </li>
              <li>
                <b>Stock List</b> : This tab is to display any Stock List
                related to the Outlet Stock.
              </li>
            </ul>
          </li>
        </ul>
      </Typography>
    </React.Fragment>
  );
};

export default StockManagement;
